import {ProductionStage} from "../production-stage/ProductionStage";

export interface DowntimeAct {
    documentNumber: number;
    description: string;
    productionTaskDocumentNumber: number;
    status: DowntimeActStatus;
    productionOrderDocumentNumber: number;
    productionStage: ProductionStage;
    creator: DowntimeActCreator;
    notificationTime: string;
}

export interface DowntimeActCreator {
    id: number;
    username: string;
    firstname: string;
    lastname: string;
    middlename: string;
}

export enum DowntimeActStatus {
    NOTIFICATION = 'NOTIFICATION',
    CAUSE_ELIMINATED = 'CAUSE_ELIMINATED',
}

export interface DowntimeActJournalFilter {
    productionStageId?: number[];
    productionOrderDocumentNumber?: number[];
    productionTaskDocumentNumber?: number[];
    creatorId?: number[];
    status?: number[];
}

export interface CreateDowntimeAct {
    productionTaskDocumentNumber: number;
    description: string;
}

export interface UpdateDowntimeAct {
    description: string;
}

export interface UpdateDowntimeActStatus {
    status: DowntimeActStatus;
}